var _path, _path2, _path3, _path4, _path5, _path6;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPrinting(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 21,
    viewBox: "0 0 17 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 2.65918H5.63824V5.31801H0V2.65918Z",
    fill: "#333333"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M16.9401 2.65918V5.31801H11.3018H11.2935V2.65918H11.3018H16.9401Z",
    fill: "#333333"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M7.96729 10.9873H8.96424V12.648H7.96729V10.9873Z",
    fill: "#333333"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M9.62596 15.3072C8.7044 15.3072 7.96715 14.5607 7.96715 13.6465H8.96411C8.96411 14.0155 9.26571 14.3091 9.63433 14.3091H13.9405C14.8621 14.3091 15.5993 15.0556 15.5993 15.9698C15.5993 16.884 14.8537 17.6305 13.9405 17.6305H3.32587C2.95725 17.6305 2.66403 17.9241 2.66403 18.2931C2.66403 18.6622 2.95725 18.9558 3.32587 18.9558H7.96715C8.8887 18.9558 9.62596 19.7022 9.62596 20.6165V20.952H8.629V20.6165C8.629 20.2474 8.3274 19.9539 7.95878 19.9539H3.3175C2.39594 19.9539 1.65869 19.2074 1.65869 18.2931C1.65869 17.3705 2.40432 16.6324 3.3175 16.6324H13.9321C14.3007 16.6324 14.594 16.3305 14.594 15.9698C14.594 15.6008 14.2924 15.3072 13.9321 15.3072H9.62596Z",
    fill: "#333333"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M8.6292 12.9835H8.2941C8.10979 12.9835 7.95898 12.8325 7.95898 12.648C7.95898 12.4635 8.10979 12.3125 8.2941 12.3125H8.6292C8.81351 12.3125 8.96431 12.4635 8.96431 12.648C8.96431 12.8325 8.81351 12.9835 8.6292 12.9835Z",
    fill: "#333333"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M11.2932 0.335497C11.2932 0.150973 11.1424 0 10.9581 0H5.96499C5.78068 0 5.62988 0.150973 5.62988 0.335497C5.62988 0.343884 5.62988 0.343885 5.62988 0.352272V2.66722V5.32604V8.65587L7.63216 10.9876H7.95889H8.95584H9.29095L11.2932 8.65587V5.32604V2.66722V0.335497Z",
    fill: "#333333"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPrinting);
export default __webpack_public_path__ + "static/media/printing.16ab86d809a90b0efdfbe35501edca97.svg";
export { ForwardRef as ReactComponent };